<template>
  <div class="upload-image flex flex-wrap items-center p-4">
    <span class="mr-2">{{ $t('chat.please') }}</span>
    <button class="button mr-2 px-3 relative" @click="$emit('upload-picture')">
      <input
        class="input absolute"
        type="file"
        v-bind="inputOrder[0].attr"
        @input="e => $emit('upload-image', e)"
      />
      {{ inputOrder[0].text }}
    </button>
    <span class="mr-2">{{ $t('chat.or') }}</span>
    <button class="button mr-2 px-3 relative" @click="$emit('upload-picture')">
      <input
        class="input absolute"
        type="file"
        v-bind="inputOrder[1].attr"
        @input="e => $emit('upload-image', e)"
      />
      {{ inputOrder[1].text }}
    </button>
    {{ $t('chat.for_fitting_look') }}
  </div>
</template>
<script>
import reverse from 'lodash/reverse';

export default {
  computed: {
    inputOrder() {
      const inputs = [
        { text: this.$t('chat.upload'), attr: { accept: 'image/*' } },
        { text: this.$t('chat.take_picture'), attr: { capture: 'environment' } },
      ];
      return this.$i18n.locale === 'zh-tw' ? reverse(inputs) : inputs;
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-image {
  font-size: 16px;

  .button {
    border-radius: 38px;
    border: 1px solid var(--primary-text);

    &:active {
      background-color: var(--primary-text);
      color: var(--primary-button-text);
    }

    .input {
      opacity: 0;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>
